const API_BASE_URL = 'https://openapi.nocodebackend.com';
const BEARER_TOKEN = '43c02f67f2fd17d857a2672aac2bbec25cc02adecb47b5bdd806dd6e73a9';
const INSTANCE = '53730_appointment_system';

const apiHeaders = {
  'Authorization': `Bearer ${BEARER_TOKEN}`,
  'Content-Type': 'application/json'
};

// Utility function to handle API responses
const handleResponse = async (response) => {
  console.log('API Response Status:', response.status, response.statusText);
  console.log('API Response Headers:', Object.fromEntries(response.headers.entries()));
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error('API Error Response:', errorText);
    throw new Error(`API Error: ${response.status} - ${errorText}`);
  }
  
  const data = await response.json();
  console.log('API Response Data:', data);
  return data;
};

// Appointments API
export const appointmentsAPI = {
  // Create a new appointment
  create: async (appointmentData) => {
    console.log('Creating appointment:', appointmentData);
    const response = await fetch(
      `${API_BASE_URL}/create/appointments?Instance=${INSTANCE}`,
      {
        method: 'POST',
        headers: apiHeaders,
        body: JSON.stringify(appointmentData)
      }
    );
    return handleResponse(response);
  },

  // Get all appointments
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_BASE_URL}/read/appointments?Instance=${INSTANCE}${queryString ? '&' + queryString : ''}`;
    console.log('Fetching appointments from:', url);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: apiHeaders
    });
    return handleResponse(response);
  },

  // Get appointment by ID
  getById: async (id) => {
    const response = await fetch(
      `${API_BASE_URL}/read/appointments/${id}?Instance=${INSTANCE}`,
      {
        method: 'GET',
        headers: apiHeaders
      }
    );
    return handleResponse(response);
  },

  // Update appointment
  update: async (id, appointmentData) => {
    console.log('Updating appointment:', id, appointmentData);
    const response = await fetch(
      `${API_BASE_URL}/update/appointments/${id}?Instance=${INSTANCE}`,
      {
        method: 'PUT',
        headers: apiHeaders,
        body: JSON.stringify(appointmentData)
      }
    );
    return handleResponse(response);
  },

  // Delete appointment
  delete: async (id) => {
    const response = await fetch(
      `${API_BASE_URL}/delete/appointments/${id}?Instance=${INSTANCE}`,
      {
        method: 'DELETE',
        headers: apiHeaders
      }
    );
    return handleResponse(response);
  },

  // Search appointments
  search: async (searchData) => {
    const response = await fetch(
      `${API_BASE_URL}/search/appointments?Instance=${INSTANCE}`,
      {
        method: 'POST',
        headers: apiHeaders,
        body: JSON.stringify(searchData)
      }
    );
    return handleResponse(response);
  }
};

// Availability Settings API
export const availabilityAPI = {
  // Get all availability settings
  getAll: async () => {
    const url = `${API_BASE_URL}/read/availability_settings?Instance=${INSTANCE}`;
    console.log('Fetching availability settings from:', url);
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: apiHeaders
      });
      
      // Add more detailed logging
      console.log('Availability API Response Status:', response.status);
      console.log('Availability API Response OK:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Availability API Error:', {
          status: response.status,
          statusText: response.statusText,
          errorText: errorText,
          url: url
        });
        throw new Error(`Availability API Error: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Availability API Response Data:', data);
      return data;
    } catch (error) {
      console.error('Failed to fetch availability settings:', error);
      throw error;
    }
  },

  // Create availability setting
  create: async (availabilityData) => {
    console.log('Creating availability setting:', availabilityData);
    const response = await fetch(
      `${API_BASE_URL}/create/availability_settings?Instance=${INSTANCE}`,
      {
        method: 'POST',
        headers: apiHeaders,
        body: JSON.stringify(availabilityData)
      }
    );
    return handleResponse(response);
  },

  // Update availability setting
  update: async (id, availabilityData) => {
    console.log('Updating availability setting:', id, availabilityData);
    const response = await fetch(
      `${API_BASE_URL}/update/availability_settings/${id}?Instance=${INSTANCE}`,
      {
        method: 'PUT',
        headers: apiHeaders,
        body: JSON.stringify(availabilityData)
      }
    );
    return handleResponse(response);
  }
};

// Blocked Dates API
export const blockedDatesAPI = {
  // Get all blocked dates
  getAll: async () => {
    const url = `${API_BASE_URL}/read/blocked_dates?Instance=${INSTANCE}`;
    console.log('Fetching blocked dates from:', url);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: apiHeaders
    });
    return handleResponse(response);
  },

  // Create blocked date
  create: async (blockedDateData) => {
    console.log('Creating blocked date:', blockedDateData);
    const response = await fetch(
      `${API_BASE_URL}/create/blocked_dates?Instance=${INSTANCE}`,
      {
        method: 'POST',
        headers: apiHeaders,
        body: JSON.stringify(blockedDateData)
      }
    );
    return handleResponse(response);
  },

  // Delete blocked date
  delete: async (id) => {
    console.log('Deleting blocked date:', id);
    const response = await fetch(
      `${API_BASE_URL}/delete/blocked_dates/${id}?Instance=${INSTANCE}`,
      {
        method: 'DELETE',
        headers: apiHeaders
      }
    );
    return handleResponse(response);
  }
};